__webpack_require__.p = "/scrana/";